import React, { useState, useCallback } from "react";
import {
  AppBar,
  Tabs,
  Toolbar,
  Tab,
  useMediaQuery,
  useTheme,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DrawerComp from "../drawer/DrawerComp";
import logo from "../../images/enablingLogo.jpg";
import Cookies from "js-cookie";

const PAGES = ["Home", "About Us", "Products", "Gallery", "Contact Us"];
const PATHS = ["/", "/about", "/product", "/gallery", "/contact"];

export const NavBar = React.memo(() => {
  const [value, setValue] = useState(false);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  useLocation(); // subscribe to route changes so auth state refreshes after login/logout

  const isLoggedIn = !!Cookies.get("authToken");
  const role = localStorage.getItem("dealerInfo")
    ? "Dealer"
    : localStorage.getItem("CreateProfile")
    ? "Sub Admin"
    : "Admin";

  const handleLoginClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleLogout = useCallback(() => {
    Cookies.remove("authToken");
    localStorage.removeItem("dealerInfo");
    localStorage.removeItem("CreateProfile");
    navigate("/");
  }, [navigate]);

  return (
    <React.Fragment>
      <AppBar position="fixed" sx={{ background: "#063970" }}>
        <Toolbar>
          <img src={logo} alt="logo" style={{ width: "70px", height: "50px", cursor: "pointer" }}/>
          {isMatch ? (
            <>
              <Typography sx={{ paddingLeft: '10%' }}>Enabling E-Vehicles</Typography>
              <DrawerComp />
            </>
          ) : (
            <>
              <Tabs
                sx={{ marginLeft: "5vw" }}
                textColor="inherit"
                value={value}
                onChange={(e, value) => setValue(value)}
                indicatorColor="none"
              >
                {PAGES.map((page, index) => (
                  <Tab
                    label={page}
                    key={index}
                    component={Link}
                    to={PATHS[index]}
                    selected={value === index}
                  />
                ))}
                {isLoggedIn ? (
                  <Tab
                    label={`${role} | Logout`}
                    onClick={handleLogout}
                    sx={{ color: "#ff6b6b", "&:hover": { color: "#ff4444" } }}
                  />
                ) : (
                  <Tab label="Login" onClick={handleLoginClick} />
                )}
              </Tabs>
              {!isLoggedIn && (
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  MenuListProps={{
                    sx: {
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                      backdropFilter: "blur(10px)",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <MenuItem
                    component={Link}
                    to="/admin"
                    onClick={handleMenuClose}
                    sx={{ '&:hover': { backgroundColor: "#f0f0f0" } }}
                  >
                    Admin
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    to="/subAdminLogin"
                    onClick={handleMenuClose}
                    sx={{ '&:hover': { backgroundColor: "#f0f0f0" } }}
                  >
                    SubAdmin
                  </MenuItem>
                  <MenuItem
                    component={Link}
                    to="/dealerLogin"
                    onClick={handleMenuClose}
                    sx={{ '&:hover': { backgroundColor: "#f0f0f0" } }}
                  >
                    Dealer
                  </MenuItem>
                </Menu>
              )}
            </>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar />
    </React.Fragment>
  );
});